import api from '@/api/companyManagement'

const state = {

}

const actions = {
  getCompany (context, companyId) {
    return api.getCompany(companyId)
  },
  updateCompany (context, { companyId, companyData }) {
    return api.updateCompany(companyId, companyData)
  },
  addCompany (context, companyData) {
    return api.addCompany(companyData)
  },
  deleteCompany (context, companyId) {
    return api.deleteCompany(companyId)
  },
  parentCompanyValidate (context, params) {
    return api.parentCompanyValidate(params)
  },
  getCompanyPremiumInfo (context, { companyId }) {
    return api.getCompanyPremiumInfo(companyId)
  },
  saveCompanyPremium (context, premiumInfo) {
    return api.saveCompanyPremium(premiumInfo)
  },
  getCompanyApprovalList (context, params) {
    return api.getCompanyApprovalList(params)
  },
  updateCompanyApprovalStatus (context, params) {
    return api.updateCompanyApprovalStatus(params)
  },
  getCompanyApprovalInfo (context, companyId) {
    return api.getCompanyApprovalInfo(companyId)
  },
  getCompanyApprovalEditInfo (context, companyId) {
    return api.getCompanyApprovalEditInfo(companyId)
  },
  updateCompanyApprovalInfo (context, { companyId, data }) {
    return api.updateCompanyApprovalInfo(companyId, data)
  },
  getCompanyProfileInfo (context, params) {
    return api.getCompanyProfileInfo(params)
  },
  updateCompanyProfileInfo (context, data) {
    return api.updateCompanyProfileInfo(data)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
